export default "__VITE_ASSET__CvPHM3Hw__"